var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetFlowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_4145)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#7043FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_78_4145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4853 24.4848C19.8063 29.1637 12.1936 29.1637 7.5147 24.4848C2.83577 19.8059 2.83577 12.1932 7.5147 7.51423C12.1936 2.8353 19.8063 2.8353 24.4853 7.51423C29.1642 12.1932 29.1642 19.8059 24.4853 24.4848ZM8.92891 8.92844C5.02993 12.8274 5.02993 19.1716 8.92891 23.0706C12.8279 26.9696 19.1721 26.9696 23.071 23.0706C26.97 19.1716 26.97 12.8274 23.071 8.92844C19.1721 5.02946 12.8279 5.02946 8.92891 8.92844ZM20.2426 13.1711L13.1716 20.2422C12.7812 20.6325 12.1477 20.6325 11.7573 20.2422C11.367 19.8518 11.367 19.2183 11.7573 18.8279L18.8284 11.7569C19.2194 11.3658 19.8523 11.3665 20.2426 11.7569C20.6329 12.1472 20.6337 12.7801 20.2426 13.1711ZM20.2426 20.2422C19.8523 20.6325 19.2194 20.6332 18.8284 20.2422L11.7573 13.1711C11.367 12.7808 11.367 12.1472 11.7573 11.7569C12.1477 11.3665 12.7812 11.3665 13.1716 11.7569L20.2426 18.8279C20.6337 19.219 20.6329 19.8518 20.2426 20.2422Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_4145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_78_4145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 3.99951)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetFlowIcon);
export default __webpack_public_path__ + "static/media/reset_flow_icon.f18241562f33d4b75181858aac1be78e.svg";
export { ForwardRef as ReactComponent };